import { MenuOutlined } from "@ant-design/icons";
import { Drawer, Grid } from "antd";
import * as React from "react";
import { BaseMenu, LogoMenuItem } from '../../base-react/components/BaseMenu';
import { _T } from "../../base-react/src/Localization";
import { SiderMenu } from "./Sider";
const { useBreakpoint } = Grid;
export const ManagerMenu = ({ event_id }) => {
    const screens = useBreakpoint();
    const [drawerVisible, setDrawerVisible] = React.useState(false);
    const docsMenuItem = {
        key: "docs",
        label: (React.createElement("a", { href: "https://docs.vote4dance.com", target: "_blank", rel: "noopener noreferrer" }, _T('header.docs'))),
    };
    const handleMenuClick = () => {
        setDrawerVisible(true);
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(BaseMenu, { children: screens.xs ? [
                {
                    key: "menu",
                    icon: React.createElement(MenuOutlined, null),
                    onClick: handleMenuClick
                },
                docsMenuItem,
            ] : [
                docsMenuItem,
            ] }),
        React.createElement(Drawer, { title: React.createElement(LogoMenuItem, { disableBackground: true }), placement: "left", onClose: () => setDrawerVisible(false), open: drawerVisible, size: 250, styles: {
                header: { padding: 0 },
                body: { padding: 0 },
            } },
            React.createElement(SiderMenu, { event_id: event_id, onClick: () => setDrawerVisible(false) }))));
};
